import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { Box, Typography } from "@mui/material";
import { createContext, useContext, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { minValueForFreeDelivery } from "../../../../src/constants/constants";
import { ReactComponent as Account } from "../../../assets/account.svg";
import { ReactComponent as Cart } from "../../../assets/cart.svg";
import { ReactComponent as Categories } from "../../../assets/categories.svg";
import { ReactComponent as Home } from "../../../assets/clienthome.svg";

export const NavBarContext = createContext();

const NavbarContainer = {
  backgroundColor: "#ffffff",
  boxShadow: "0px 2px 7px rgba(0, 0, 0, 0.84)",
  borderRadius: "20px 20px 0px 0px;",
  padding: "16px 0px",
  position: "fixed",
  bottom: "0",
  width: "100%",
  minHeight: "5vh",
  zIndex: 10,
  transition: "transform 0.3s ease-in-out",
};

const NavbarDiv = {
  display: "flex",
  justifyContent: "space-evenly",
};

const NavItemStyle = {
  borderRadius: "50%",
  width: "54px",
  height: "54px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: "black",
};

const Navbar = () => {
  const price = parseFloat(localStorage.getItem("cartprice"));
  const items = useContext(NavBarContext);
  const [showNavbar, setShowNavbar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const scrollThreshold = 1; // Scroll threshold to hide navbar
  // const [items, setitems] = useState()
  const [scrollTimeout, setScrollTimeout] = useState(null);

  const controlNavbar = () => {
    if (scrollTimeout) {
      clearTimeout(scrollTimeout);
    }
    // If user scrolls down more than the threshold
    if (window.scrollY - lastScrollY > scrollThreshold) {
      setShowNavbar(false);
    }
    // If user scrolls up
    else if (lastScrollY - window.scrollY > scrollThreshold) {
      setShowNavbar(true);
    }

    // Detect when scrolling stops
    const timeout = setTimeout(() => {
      setShowNavbar(true);
    }, 500);

    setScrollTimeout(timeout);
    setLastScrollY(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener("scroll", controlNavbar);

    return () => {
      window.removeEventListener("scroll", controlNavbar);
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
    };
  }, [lastScrollY, scrollTimeout]);

  useEffect(() => {
    if (localStorage.getItem("cart")) {
      let cartarr = JSON.parse(localStorage.getItem("cart"));
      let num = 0;
      cartarr?.forEach((element) => {
        if (element.length === 3 && parseInt(element[2]) > 0) num++;
        else if (element.length === 2 && parseInt(element[1]) > 0) num++;
      });
      if (num > 0) items.setItems(num);
      else items.setItems(0);
    }
  }, []);

  const storageCart = Array.isArray(JSON.parse(localStorage.getItem("cart")))
    ? JSON.parse(localStorage.getItem("cart")).filter(
        ([productID, count]) => count > 0,
      )
    : [];

  return (
    <Box
      sx={{
        ...NavbarContainer,
        transform: showNavbar ? "translateY(0)" : "translateY(100%)",
      }}
    >
      {price < minValueForFreeDelivery && (
        <Box
          sx={{
            // backgroundColor: "#e9f8e0",

            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
            padding: "6px 12px",
            borderRadius: "8px",
            marginBottom: "8px",
            width: "90%",
            marginX: "auto",
          }}
        >
          <LocalShippingIcon color="primary" fontSize="small" />
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 600,
              fontFamily: "Poppins, sans-serif",
              color: "#333333",
              lineHeight: "20px",
              letterSpacing: "0.2px",
              textAlign: "center",
              marginTop: "4px",
            }}
          >
            Shop for ₹{minValueForFreeDelivery - price} and get free delivery
          </Typography>
        </Box>
      )}

      <Box sx={NavbarDiv}>
        <NavLink
          to="/home"
          style={{ textDecoration: "none" }}
          className={({ isActive }) =>
            isActive ? "active-navbar-class" : "not-active-navbar-class"
          }
        >
          <Box sx={NavItemStyle} className="nav-items">
            <Home />
          </Box>
        </NavLink>

        <NavLink
          to="/category"
          style={{ textDecoration: "none" }}
          className={({ isActive }) =>
            isActive ? "active-navbar-class" : "not-active-navbar-class"
          }
        >
          <Box sx={NavItemStyle} className="nav-items">
            <Categories />
          </Box>
        </NavLink>

        <NavLink
          to="/cart"
          style={{ textDecoration: "none" }}
          className={({ isActive }) =>
            isActive ? "active-navbar-class" : "not-active-navbar-class"
          }
        >
          <Box sx={NavItemStyle} className="nav-items">
            <Box
              sx={{
                borderRadius: "100%",
                backgroundColor: "#F37A20",
                position: "absolute",
                width: "5vw",
                display: "flex",
                alignItems: "center",
                marginBottom: "20px",
                marginLeft: "25px",
                justifyContent: "center",
              }}
            >
              {storageCart.length > 0 ? <>{storageCart.length}</> : <></>}
            </Box>
            <Cart />
          </Box>
        </NavLink>
        <NavLink
          to="/profile"
          style={{ textDecoration: "none" }}
          className={({ isActive }) =>
            isActive ? "active-navbar-class" : "not-active-navbar-class"
          }
        >
          <Box sx={NavItemStyle} className="nav-items">
            <Account />
          </Box>
        </NavLink>
      </Box>
    </Box>
  );
};

export default Navbar;
